import { Flex, Heading, useBoolean } from '@chakra-ui/react'
import type { InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { createContext, useEffect, useState } from 'react'

import { ContractsExportForm } from '@/containers/export/ContractsExportForm'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ContractsList } from '../../containers/contracts'
import { ExportButton } from '../../containers/export/ExportButton'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ContractsCarSearch } from '../../containers/search/carkulka/ContractsCarSearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { useGetAll } from '../../hooks/useInsuranceParams'

export const contractsCarsContext = createContext<IPaginationContext<InsuranceParamsVehiclePagedQuery>>({} as IPaginationContext<InsuranceParamsVehiclePagedQuery>)

export const ContractsCarPage = () => {
  const [isSearchOpen, setSearchOpen] = useBoolean(false)
  const [isExportOpen, setExportOpen] = useBoolean(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [filter, setFilter] = useState<InsuranceParamsVehiclePagedQuery>({
    //dateCreatedFrom: defaultDateFrom,
    listType: 2,
    pageIndex: 1,
  })

  const { data, mutateAsync: getAllAsync, isPending: isLoading } = useGetAll()
  const items = data?.data

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage])

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter])

  return (
    <Section>
      <Container>
        <PageContent>
          <contractsCarsContext.Provider value={
            {
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: setPageSize,
              updateFilter: f => setFilter(f),
              reload: () => { }
            }
          }>
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Smlouvy</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <ExportButton isOpen={isExportOpen} setOpen={setExportOpen} />
                  <SearchButton isOpen={isSearchOpen} setOpen={setSearchOpen} />
                </Flex>
              }
            />

            {isSearchOpen && <ContractsCarSearch />}
            {isExportOpen && <ContractsExportForm />}

            <ContractsList contracts={items?.items ?? []} withPaginator />
          </contractsCarsContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
